import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../AuthContext';

export default function AdminRoute({ children }) {
  const { currentUser } = useAuth();
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!currentUser) { setChecking(false); return; }
      try {
        const db = getFirestore();
        const snap = await getDoc(doc(db, 'users', currentUser.uid));
        setIsAdmin(snap.exists() && snap.data().is_admin === true);
      } catch (err) {
        console.error('Error checking admin status:', err);
      } finally {
        setChecking(false);
      }
    };
    check();
  }, [currentUser]);

  if (checking) return <div style={{ padding: 40 }}>Checking access...</div>;
  if (!currentUser || !isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}